import { HStack, Text } from '@chakra-ui/react';
import { FileText, Video } from 'lucide-react';
import DomainIconTiles from '@/modules/content/common/DomainIconTiles';
import formatRelativeAge from '@/modules/content/common/formatRelativeAge';
import { TContent, TContentDomain } from '@/types/Content.types';

// Footer row: content type and how long ago it was published, with the wellness-domain
// tiles pushed to the right.
const PublishedMetaRow = ({ content, isOnDark = false }: { content: TContent; isOnDark?: boolean }) => {
  const age = formatRelativeAge(content.publishedAt ?? content.createdAt);
  const TypeIcon = content.type === 'video' ? Video : FileText;

  return (
    <HStack width="100%" justify="space-between" align="center" gap="10px">
      <HStack gap="6px" color={isOnDark ? 'whiteAlpha.800' : 'text.mediumGray'}>
        <TypeIcon size={13} />
        {age && (
          <Text fontSize="10px" fontWeight={700} letterSpacing="0.06em">
            {age}
          </Text>
        )}
      </HStack>
      {content.domains?.length > 0 && (
        <DomainIconTiles
          domains={content.domains as TContentDomain[]}
          max={3}
          variant={isOnDark ? 'overlay' : 'muted'}
        />
      )}
    </HStack>
  );
};

export default PublishedMetaRow;
